import { handleAction } from 'redux-actions'

import { clearToast } from './actions'
import defaultState from './defaultState'

export default handleAction(clearToast, () => defaultState, defaultState)
